import React, { PropsWithChildren } from 'react';
import { Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Slide } from '@mui/material';
import OneButtonDialogActionBar from '../../controls/actionBars/DialogActionButtonBars/OneButtonDialogActionBar';
import { TransitionProps } from '@mui/material/transitions';


// create a Slide transition to direct how the Dialog will appear
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" timeout={{enter: 500}} ref={ref} {...props} />;
});

export interface IOneButtonDialogProps extends PropsWithChildren<unknown> {
  showDialog: boolean,
  headerText: string,
  bodyText: string,
  buttonText: string,
  onButtonClick: () => void,
}

const OneButtonDialog: React.FC<IOneButtonDialogProps> = (props) => {

  OneButtonDialog.displayName = 'OneButtonDialog';

  const { showDialog, headerText, bodyText, buttonText, onButtonClick } = props;

  return (
    <>
      <Dialog
        open={showDialog}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={onButtonClick}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">{headerText}</DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            {bodyText}
          </DialogContentText>
        </DialogContent>
        <Divider />
        <OneButtonDialogActionBar
          buttonLabel={buttonText}
          onButtonClick={onButtonClick}
        />
      </Dialog>
    </>

  );
}

export default OneButtonDialog;
